import { useLPSuspenseQuery } from '../lib/hooks/useLPQuery';

export const useManagerExportActivityLogQuery = () => {
  const queryKey: string[] = ['ActivityLogExportQuery'];
  const endpoint = `/manager/export/teamLearners`;
  return useLPSuspenseQuery<TeamActivityLog[]>(queryKey, endpoint, undefined, undefined, { method: 'POST' });
};

export type TeamActivityLog = {
  level: string;
  cyberIqPoints: number;
  name: string;
  jobTitle: boolean;
  trainings?: {
    assigned: number;
    completed: number;
  };
  department: string;
  email: string;
};
